import { render } from "./motifView.vue?vue&type=template&id=6fc4e0a0"
import script from "./motifView.vue?vue&type=script&lang=js"
export * from "./motifView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__